import './DetailsContent.scss';

import { useParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchDetails } from "../../../slices/detailsSlice";

import DetailsTools from "../DetailsTools/DetailsTools";

const DetailsContent = ({id}) => {
    const dispatch = useDispatch();
    const token = useSelector((state) => state.auth.token?.data?.token || state.auth.token);
    const attributes = useSelector((state) => state.details?.columns?.attributes || []);
    const data = useSelector((state) => state.details?.data);

    useEffect(() => {
        dispatch(fetchDetails({ departureId: id, token }));
    }, [dispatch, id, token]);

    const fields = Array.isArray(attributes)
        ? attributes.map((attribute) => {
            let value = data?.attributes?.[attribute.key];

            if (typeof value === "boolean") {
                value = value ? "Да" : "Нет";
            } else if (value === undefined || value === null || value === "") {
                value = "Отсутствует";
            }

            return {
                key: attribute.key,
                name: attribute.alias || attribute.name,
                value,
            };
        })
        : [];

    return (
        <div className="details-content">
            <div className="details-content_container">
                <div className="details-content_tools">
                    <DetailsTools title="Донесение" id={id}/>
                </div>

                <div className="details-content_fields">
                    {fields.map((item) => (
                        <div className="details-content_field" key={item.key}>
                            <div className="details-content_title">{item.name}</div>
                            <div className="details-content_value">{item.value}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default DetailsContent;